var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserKind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#15B79E"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_155_55226)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    transform: "matrix(1 0 0 -1 2 14)",
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0728 11.0002C10.3922 11.0002 10.7084 10.9363 11.0029 10.8127C11.2976 10.6892 11.5649 10.5082 11.7888 10.2803C12.2445 9.81634 12.5 9.19183 12.5 8.5415L12.4971 8.41992C12.4673 7.81392 12.216 7.23833 11.7888 6.80347L8 2.96631L4.21118 6.80347C3.78405 7.23833 3.53271 7.81392 3.50293 8.41992L3.5 8.5415C3.5 9.19183 3.75545 9.81634 4.21118 10.2803C4.40726 10.4796 4.63626 10.6432 4.88794 10.7637L4.99707 10.8127C5.29162 10.9361 5.60789 10.9995 5.92725 10.9995L6.04663 10.9966C6.3252 10.9827 6.59962 10.9208 6.85742 10.8127C7.15205 10.6893 7.4193 10.508 7.64331 10.2803L8 9.92065L8.35669 10.2803C8.58036 10.5084 8.84726 10.6899 9.14185 10.8135C9.43651 10.9371 9.75321 11.0005 10.0728 11.0002ZM10.0728 10.2502C9.85323 10.2504 9.63508 10.2069 9.43262 10.1221C9.23 10.0371 9.04592 9.91201 8.89209 9.75513L8.88916 9.7522L8 8.85498L7.11084 9.7522L7.10864 9.75439C6.95443 9.91119 6.77021 10.0356 6.56738 10.1206C6.36462 10.2056 6.14709 10.2495 5.92725 10.2495C5.70733 10.2495 5.4892 10.2056 5.28638 10.1206C5.08369 10.0356 4.89997 9.91109 4.74585 9.75439L4.74512 9.75513C4.42736 9.43148 4.25 8.99508 4.25 8.5415C4.25007 8.08859 4.42743 7.65354 4.74438 7.33008L8 4.03418L11.2549 7.33008C11.5721 7.65357 11.7499 8.08842 11.75 8.5415C11.75 8.99524 11.5721 9.43144 11.2541 9.75513C11.1 9.912 10.9157 10.0363 10.7129 10.1213C10.5102 10.2063 10.2926 10.2502 10.0728 10.2502Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.0002L6.5 12.5002L9.5 12.5002L8 11.0002Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_155_55226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "matrix(1 0 0 -1 2 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserKind);
export default __webpack_public_path__ + "static/media/user-kind.b948716b3d91aedd2bb8b74e16c2bcd0.svg";
export { ForwardRef as ReactComponent };